import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "references-index-pane iodine-no-scroll-y full-height flex-grow-1 flex-shrink-0" }

import ReferencesHeader from 'components/references/ReferencesHeader.vue';
import ReferencesSearch from 'components/references/ReferencesSearch.vue';
import ReferencesBrowse from 'components/references/ReferencesBrowse.vue';
import {ref} from 'vue';
import { GrouperLayoutMode } from 'src/services/IodineGrouperService';
import { useLayoutStore } from 'stores/layout-store';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesIndex',
  setup(__props) {

const { layoutMode } = storeToRefs(useLayoutStore());

const referencesOption = ref('search');
function optionChanged(value) {
    referencesOption.value = value;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ReferencesHeader, { onReferencesOptionChanged: optionChanged }),
    _createElementVNode("div", {
      class: _normalizeClass(["iodine-padding-md", {'reference-index-container': _unref(layoutMode) === _unref(GrouperLayoutMode).fullScreen, 'references-embedded-index-container': _unref(layoutMode) === _unref(GrouperLayoutMode).consolidated}])
    }, [
      (referencesOption.value === 'browse')
        ? (_openBlock(), _createBlock(ReferencesBrowse, { key: 0 }))
        : _createCommentVNode("", true),
      (referencesOption.value === 'search')
        ? (_openBlock(), _createBlock(ReferencesSearch, { key: 1 }))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})